<template>
  <div class="w12">
    <asset-header></asset-header>

    <!-- 출금제한 -->
    <div v-if="noDepositAddress" class="fs12 pt12 pl12 pr12 pb12">
      입금주소를 먼저 생성해주세요.<br />
      입금주소가 없으면 출금 신청이 불가능합니다.
    </div>
    <div
      v-else-if="
        activeCoin.ioOutEnable == 'N' ||
          (userInfo.meta.banWithdrawal && userInfo.meta.banWithdrawal === 'Y')
      "
      class="obstruct-wrap"
    >
      <div class="title">
        {{
          $t("withdraw.obstruct.withdraw", [
            activeCoin.code == "KRW" ? $t("원화") : activeCoin.code,
          ])
        }}
      </div>
      <div class="text-box">
        <p v-if="userInfo.meta.banWithdrawal === 'Y'">
          출금이 제한된 사용자입니다. 고객센터에 문의해주세요.
        </p>
        <template v-else>
          <p>{{ $t("withdraw.obstructNoti.withdraw[0]") }}</p>
          <p>{{ $t("withdraw.obstructNoti.withdraw[1]") }}</p>
        </template>
      </div>
    </div>
    <!-- // 출금제한 -->
    <!-- 정상 -->
    <div v-else>
      <div class="withdraw-page padding-content">
        <!-- <div class="withdraw-page padding-content"> -->
        <!-- 원화&&외국인 출금-->
        <div v-if="userInfo.foreignYn == 'Y' && activeCoin.code == 'KRW'">
          <div class="foreign mt20 mb50">
            {{ $t("deposit.onlyKoreanCanUseKrwMarket") }}
          </div>
        </div>
        <!-- 외국인&&!원화 or 내국인&&원화, 가상자산 출금 -->
        <div v-else class="w12">
          <!-- 출금 항목 입력 -->
          <div class="w12">
            <!-- 테더 코인 출금 페이지 탭 생성 -->
            <div v-if="activeCoin.subCoins" class="withdrawal-title" flex>
              <div
                v-for="(subCoin, index) in activeCoin.subCoins"
                :key="`${subCoin.title}-${index}`"
                class="tab"
                :class="{ selected: subCoin.active }"
                @click="clickSubCoins(subCoin.title, index)"
              >
                {{ subCoin.title }}
              </div>
            </div>
            <!-- //테더 코인 출금 페이지 탭 생성 -->
            <div class="w12 can-withdraw" flex>
              <p v-if="activeCoin.code === 'KRW'" class="realWithdraw">
                {{ $t("withdraw.withdrawablePrice") }}<span>:</span>
              </p>
              <p v-else class="realWithdraw">
                {{ $t("withdraw.withdrawableQuantity") }}<span>:</span>
              </p>

              <!-- 실제 출금 가능수량 -->
              <div>
                <!-- 원화일 때 -->
                <span v-if="activeCoin.code === 'KRW'">
                  {{
                    Math.floor(maxAmount)
                      | formatNumber2(activeCoin.code === "KRW" ? 0 : 8)
                  }}
                </span>
                <!-- 내부 주소일 때 -->
                <span v-else-if="local == 'true'">
                  {{
                    localMaxAmount
                      | formatNumber2(
                        activeCoin.code === "KRW"
                          ? 0
                          : activeCoin.ciBnOutDecimalPoint
                      )
                  }}
                </span>
                <!-- TRC일 때 -->
                <span v-else-if="selectedTRC">
                  {{
                    trcMaxAmount
                      | formatNumber2(
                        activeCoin.code === "KRW"
                          ? 0
                          : activeCoin.ciBnOutDecimalPoint
                      )
                  }}
                </span>
                <!-- !KRW, !TRC, !내부 주소일 때 -->
                <span v-else>
                  {{
                    maxAmount
                      | formatNumber2(
                        activeCoin.code === "KRW"
                          ? 0
                          : activeCoin.ciBnOutDecimalPoint
                      )
                  }}
                </span>
                {{ activeCoin.code }}
              </div>
            </div>

            <div v-if="activeCoin.code !== 'KRW'" class="noti-free">
              <img
                src="../../../assets/img/common/withdrawal_icon.svg"
                alt=""
              />
              <span v-if="selectedTRC" v-html="$t('withdraw.notiFree[2]')">
              </span>
              <span v-else>
                {{ $t("withdraw.notiFree[0]") }}
              </span>
            </div>
            <!-- 입금주소 선택/입력 -->
            <div class="w12" v-if="activeCoin.code !== 'KRW'" flex>
              <!-- 지갑 타입 선택 -->
              <div class="mb15">
                <el-radio-group v-model="walletType" @change="selectedAddrType">
                  <el-radio :label="1" class="radio normal"
                    >직접입력/즐겨찾기</el-radio
                  >
                  <el-radio
                    :label="2"
                    class="radio normal"
                    :disabled="disabledPersonalWallet"
                    >개인지갑</el-radio
                  >
                </el-radio-group>
              </div>
              <!-- // 지갑 타입 선택 -->

              <!-- 거래소 선택  -->
              <div
                @click="openSelectModal"
                class="select-exchange"
                :class="{ disabled: walletType === 2 }"
              >
                {{
                  selectModalList == "0" ? "받는 거래소 선택" : selectModalList
                }}
              </div>
              <p class="keycolor fs12 mb15 mt5">
                * 받는 거래소 선택은 필수입니다.
              </p>
              <!-- // 거래소 선택 -->

              <!-- 주소록 -->
              <div class="w12 input-box book" flex>
                <div class="input-line" flex fic>
                  <select-js
                    :data="withdrawAddr"
                    :value="DA_CODE"
                    :type="type"
                    @change="setWithdraw"
                    class="selected-address"
                  />
                </div>
                <button class="pt5 pb5 pl10 pr10" @click="showAddrModal">
                  {{ $t("withdraw.addressBookManage") }}
                </button>
              </div>

              <div class="w12 input-box addr border-line" flex>
                <div
                  class="input-line exception mt20"
                  :class="{
                    empty: clickCheckButton,
                    disabled: disabledInput,
                  }"
                  flex
                  fic
                  nowrap
                >
                  <input
                    v-model="withdrawForm.address"
                    type="text"
                    maxlength="86"
                    :placeholder="$t('withdraw.enterAddressName')"
                    @click="clickAddressInput"
                    @input="checkInput"
                    :disabled="disabledInput"
                    class="address"
                  />
                </div>
                <!-- <button @click="pasteAddr">붙여넣기</button> -->
                <div class="noti">
                  * {{ $t("withdraw.checkAddress[0]") }}
                  <span>{{ $t("withdraw.checkAddress[1]") }}</span>
                  {{ $t("withdraw.checkAddress[2]") }}
                </div>
              </div>
              <!-- //입금 주소 입력 -->
            </div>
            <!-- 데스티네이션 태그 -->
            <div v-if="activeCoin.tagYn === 'Y'" class="w12 mt20" flex fic>
              <div class="w12 addr-memo mb5">{{ $t("withdraw.tag") }}</div>
              <div class="w12 input-box addr border-line">
                <div
                  class="input-line exception"
                  :class="{
                    empty: clickCheckTagButton,
                    disabled: disabledInput,
                  }"
                  flex
                  fic
                >
                  <input
                    v-model="withdrawForm.tag"
                    type="text"
                    maxlength="40"
                    placeholder="(선택입력)"
                    @click="clickTagInput"
                    :disabled="disabledInput"
                    class="address"
                  />
                </div>
              </div>
              <div class="w12 mt5 tag-info">
                * 받으실 지갑 또는 거래소에 Destination Tag가 존재하는 경우
                반드시 입력해야 합니다.
                <!--
                {{
                  $t("withdraw.destinationInfo", [
                    $i18n.locale == "ko" ? activeCoin.name : activeCoin.code,
                  ])
                }}-->
              </div>
            </div>
            <!-- //데스티네이션 태그 -->

            <!-- 출금주소체크 버튼 : 태그 필수값 아님 -->
            <button
              class="checkAddress"
              @click="checkInnerAddress(activeCoin.id)"
              v-if="activeCoin.code !== 'KRW' && walletType === 1"
              :disabled="disabledInput"
            >
              {{ $t("withdraw.checkAddress[1]") }}
            </button>
            <!-- //출금주소체크 버튼 -->

            <!-- 출금 금액, 수량 입력 -->
            <div class="w12 input-box mt20" flex fic>
              <div
                class="input-line"
                :class="{
                  disabled: disabledAmount,
                }"
                flex
                fje
                fic
                nowrap
              >
                <div flex fje fic nowrap>
                  <input
                    type="number"
                    pattern="[0-9]*"
                    inputmode="decimal"
                    class="roboto amount"
                    v-model="inputAmount"
                    @keyup="
                      getLimitAmount(
                        inputAmount,
                        activeCoin.ciBnOutDecimalPoint
                      )
                    "
                    :disabled="disabledAmount"
                  />
                  <div style="width: 60px">
                    {{ activeCoin.code }}
                  </div>
                </div>
              </div>
              <!-- 최대 버튼 -->
              <button
                @click="maxAmountChx(activeCoin.ciBnOutDecimalPoint)"
                :disabled="disabledAmount"
              >
                {{ $t("withdraw.max") }}
              </button>
              <!-- //최대 버튼 -->
            </div>
            <div v-if="activeCoin.code === 'KRW'" class="W12 front mt4">
              {{ $t("withdraw.min", [minAmount]) }}
            </div>
            <div v-else>
              <div class="W12 front mt4">
                {{ $t("withdraw.minAmount", [minAmount]) }}
              </div>
            </div>
            <div
              v-if="activeCoin.code === 'NFTS'"
              class="NFTS-description"
              style="margin-top: 8px; font-size: 12px"
              v-html="$t('withdraw.NFTSWithdowDesc')"
            ></div>
            <div class="travel-rule"></div>
            <!-- //출금 금액, 수량 입력 -->
            <!-- 계좌번호 -->
            <div v-if="activeCoin.code == 'KRW'" class="w12 krw-bank mt20" flex>
              <!-- <template v-if="accounts.deposit"> -->
              <div style="width: 60%" flex>
                <div class="label mr4">{{ $t("withdraw.bankAccount") }}</div>
                <div class="data">
                  {{
                    !accounts.deposit || !accounts.deposit.accountNumber
                      ? ""
                      : accounts.deposit.accountNumber
                  }}
                </div>
              </div>
              <div style="width: 40%" flex>
                <div class="label mr4">{{ $t("withdraw.bank") }}</div>
                <div class="data">
                  {{
                    !accounts.deposit || !accounts.deposit.bankName
                      ? ""
                      : accounts.deposit.bankName
                  }}
                </div>
              </div>
              <!-- </template> -->
            </div>
            <!-- <div v-else class="w12 address-box mt10" flex></div> -->
            <!-- //계좌번호 -->

            <!-- 수수료, 실제 총 출금수량 -->
            <div class="deposit-amount mt10">
              <div class="amount-wrap w12">
                <span class="w6 text">
                  <div>{{ "출금 수수료" }}</div>
                  <div v-if="activeCoin.code === 'KRW'" class="c-main mt7">
                    {{ $t("withdraw.dinalWithdrawalPrice") }}
                  </div>
                  <div
                    v-else
                    class="c-main mt7"
                    v-html="$t('withdraw.dinalWithdrawalQuantity')"
                  ></div>
                </span>
                <!-- 수수료 -->
                <span class="w6 amount-box">
                  <!-- 내부전송일 때 -->
                  <div v-if="local == 'true'" class="fee">
                    <span>0</span>
                    {{ activeCoin.code }}
                  </div>
                  <!-- trc일 때  -->
                  <div v-else-if="selectedTRC" class="fee">
                    <span>{{ trcFee }}</span>
                    {{ activeCoin.code }}
                  </div>
                  <!-- else -->
                  <div v-else class="fee">
                    {{ activeCoin.outFee }}
                    {{ activeCoin.code }}
                  </div>
                  <!-- 실제 총 출금수량: trc -->
                  <!-- <div v-if="selectedTRC" class="amount mt7">
                    {{ finalWithdrawTRC | formatNumber2(activeCoin.code === "KRW" ? 0 : 8) }}
                    {{ activeCoin.code }}
                  </div> -->
                  <!-- 실제 총 출금수량: else -->
                  <div class="amount mt7">
                    {{
                      finalWithdraw
                        | formatNumber2(activeCoin.ciBnOutDecimalPoint)
                    }}
                    {{ activeCoin.code }}
                  </div>
                </span>
              </div>

              <!-- 출금하기 버튼 -->
              <div class="w12 mt20">
                <!-- 출금하기 버튼: KRW일 때 분기 -->
                <div v-if="activeCoin.code == 'KRW'">
                  <button @click="withdraw()" class="withdraw-button">
                    {{ "다음" }}
                  </button>
                </div>
                <!-- 출금하기 버튼: 가상자산일 때 분기 -->
                <div v-else>
                  <button
                    :disabled="disabledWithdraw"
                    @click="withdraw()"
                    class="withdraw-button"
                  >
                    {{ "다음" }}
                  </button>
                </div>
              </div>
              <!-- // 출금하기 버튼 -->
            </div>
          </div>
          <!-- 한도안내 -->
          <div class="w12 limit-content">
            <div class="limit-text">
              <!-- {{ $t("withdraw.LimitGuide") }} -->
              <span
                v-html="
                  $t('withdraw.verificationLevel', [userName, newAuthLevel])
                "
              ></span>
            </div>
            <div class="w12 limit-box mt12" flex>
              <div class="box w12">
                <div class="w12" flex fjb>
                  <div>{{ $t("withdraw.oneDay") }}</div>
                  <div class="c-gray">
                    {{ $t("withdraw.max") }}
                    {{
                      withdrawLimit.limit.day
                        | formatNumber2(activeCoin.code === "KRW" ? 0 : 8)
                    }}
                    {{ activeCoin.code }}
                  </div>
                  <div class="gauge-box">
                    <div
                      class="gauge-per"
                      :style="{
                        width: `${(withdrawLimit.avail.day /
                          withdrawLimit.limit.day) *
                          100}%`,
                      }"
                    ></div>
                  </div>
                  <div class="w12">
                    {{ withdrawLimit.avail.day }}
                    {{ activeCoin.code }}
                  </div>
                </div>
              </div>
              <div class="box w12">
                <div class="w12" flex fjb>
                  <div>{{ $t("withdraw.oneMonth") }}</div>
                  <div class="c-gray">
                    {{ $t("withdraw.max") }}
                    {{
                      withdrawLimit.limit.month
                        | formatNumber2(activeCoin.code === "KRW" ? 0 : 8)
                    }}
                    {{ activeCoin.code }}
                  </div>
                  <div class="gauge-box">
                    <div
                      class="gauge-per"
                      :style="{
                        width: `${(withdrawLimit.avail.month /
                          withdrawLimit.limit.month) *
                          100}%`,
                      }"
                    ></div>
                  </div>
                  <div class="w12">
                    {{ withdrawLimit.avail.month }}
                    {{ activeCoin.code }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 이용안내 및 주의사항 -->
          <div class="noti-box mt20">
            <div class="title mb10 fs14 fw500" flex fic>
              <img
                src="../../../assets/img/icon/ico_exclamation.png"
                class="mr4"
              />
              {{ noticeTitle }}
            </div>
            <div v-html="noticeDesc" class="desc fs14"></div>
            <ul v-if="activeCoin.code === 'AMPL'" class="w12 pl18 no-dot">
              <template>
                <li class="w12 keycolor">
                  AMPL 토큰은 리베이스 시간에는 출금이 제한됩니다.
                </li>
                <li class="w12 keycolor">
                  리베이스 시간에는 출금 신청이 되지 않으며, 기존 출금건으
                  취소될 수 있으니 출금시 유의하시기 시간여유를 가지고 출금 신청
                  부탁드립니다.
                </li>
              </template>
            </ul>
          </div>
        </div>
        <!-- 입금주소등록 팝업 -->
        <el-dialog
          :visible.sync="addrModal"
          :title="title"
          class="address-modal"
          :show-close="false"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          center
        >
          <div class="modal-deposit-con">
            <div>
              <p class="fs16">
                {{ $t("mypage.주소록.입금 주소록") }}
              </p>
              <div
                v-for="(list, index) in addressLists"
                :key="index"
                class="pb10"
                style="padding: 10px 0; border-bottom: 1px solid #bec3cd"
                flex
                fjb
              >
                <div style="width: calc(100% - 55px)">
                  <p>
                    <b>{{ walletType === 1 ? list.name : list.nick }}</b>
                  </p>
                  <p class="mt10">{{ list.address }}</p>
                  <p v-if="list.tag" class="mt10">{{ list.tag }}</p>
                </div>
                <div
                  v-if="walletType === 1"
                  style="display: flex; align-items: center"
                >
                  <button @click="deleteRow(list.id)" class="delete">
                    삭제
                  </button>
                </div>
              </div>
            </div>
            <div
              is="uib-pagination"
              :boundary-links="true"
              :total-items="pagination.total"
              :max-size="3"
              :items-per-page="paginationPer"
              v-model="page"
              @change="changeAddrPage"
              class="mt10"
            ></div>
            <div v-if="walletType === 1">
              <p class="fs16 mt48">
                {{ $t("withdraw.depositRegister") }}
              </p>
              <div class="add-regist mt10">
                <div>
                  <div class="tit">{{ "별칭" }}</div>
                  <div class="txt">
                    <el-input
                      maxlength="6"
                      v-model="addrData.accountName"
                      :placeholder="$t('mypage.주소록.계좌명을 입력하세요')"
                    ></el-input>
                  </div>
                </div>
                <div>
                  <div class="tit">{{ "받는 주소" }}</div>
                  <div class="txt">
                    <el-input
                      maxlength="86"
                      v-model="addrData.address"
                      :placeholder="$t('mypage.주소록.입금주소를 입력하세요')"
                    ></el-input>
                  </div>
                </div>
                <div v-if="activeCoin.tagYn === 'Y'">
                  <div class="tit">데스티네이션태그</div>
                  <div class="txt">
                    <el-input
                      maxlength="40"
                      v-model="addrData.tag"
                      :placeholder="
                        $t('mypage.주소록.데스티네이션 태그를 입력하세요')
                      "
                    ></el-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div slot="footer" class="button-wrap" flex fjb>
            <button class="button pre" @click="closeAddrModal">
              {{ $t("confirm.close") }}
            </button>
            <button class="button next" @click="registAddr">
              {{ "등록하기" }}
            </button>
          </div>
        </el-dialog>
        <!-- //입금주소등록 팝업 -->

        <el-dialog
          :title="$t('withdraw.출금주소를 확인하세요.제목')"
          :visible.sync="addrConfirmModal"
          :show-close="false"
          :close-on-click-modal="true"
          :close-on-press-escape="true"
          class="modal-type01 popup"
          center
        >
          <div class="text-left">
            <p
              class="text-type01 mgb25"
              v-html="
                $t('withdraw.출금주소를 확인하세요.내용[0]', [
                  `${activeCoin.name}(${activeCoin.code})`,
                ])
              "
            ></p>
            <p
              class="text-type01 mgb25 mt10"
              v-html="$t('withdraw.출금주소를 확인하세요.내용[1]')"
            ></p>
            <p
              class="text-type01 mgb25 mt10"
              v-html="$t('withdraw.출금주소를 확인하세요.내용[2]')"
            ></p>
            <p class="text-type02 mt20">
              <el-checkbox class="popup" v-model="addrConfirm">{{
                $t("withdraw.출금주소를 확인하세요.위 내용을 충분히")
              }}</el-checkbox>
            </p>
          </div>
          <div slot="footer" class="button-wrap">
            <button @click="withdrawComfirmed" :disabled="!addrConfirm">
              {{ $t("confirm.ok") }}
            </button>
          </div>
        </el-dialog>

        <!-- #region 외국인 KYC 입출금 제한 안내 -->
        <el-dialog
          title="KYC of residence"
          :visible.sync="kycForeignNotAllowedModal.show"
          :show-close="false"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          class="modal-type01 popup"
          center
        >
          <div class="text-center">
            <p class="text-type01 mgb25">KYC of residence</p>
          </div>
          <span slot="footer" class="dialog-footer">
            <span @click="kycForeignNotAllowedModal.show = false">
              <span @click.prevent="kycReturnUrl" class="btn-style01">{{
                $t("confirm.ok")
              }}</span>
            </span>
          </span>
        </el-dialog>

        <el-dialog
          title="계좌등록 진행 안내"
          :visible.sync="accountAuthFailModal.show"
          :show-close="false"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          class="modal-type01 popup"
          center
        >
          <div class="text-center">
            <p class="text-type01 mgb25">
              계좌등록 완료 후 이용할 수 있는 서비스 입니다.
              <br />인증 센터로 이동하여 계좌등록 절차를 완료하여 주시기
              바랍니다.
            </p>
          </div>
          <span slot="footer" class="dialog-footer">
            <span @click="accountAuthFailModal.show = false">
              <span class="btn-style01">{{ $t("confirm.cancel") }}</span>
            </span>
            <span @click="accountAuthFailModal.show = false">
              <router-link
                :to="{ name: 'confirm' }"
                class="btn-style01 btn-style-blue"
                >{{ $t("confirm.ok") }}</router-link
              >
            </span>
          </span>
        </el-dialog>

        <el-dialog
          title="출금불가 안내"
          :visible.sync="notiBannedModal"
          :show-close="false"
          :close-on-click-modal="true"
          :close-on-press-escape="true"
          class="modal-type01"
          center
        >
          <div class="text-center">
            <p class="text-type01 mgb25">
              출금이 제한된 사용자입니다. 고객센터에 문의해주세요.
            </p>
          </div>
          <span slot="footer" class="dialog-footer">
            <span
              @click="notiBannedModal = false"
              class="btn-style01 btn-style-blue"
              >{{ $t("confirm.ok") }}</span
            >
          </span>
        </el-dialog>

        <!-- 본인인증 필요 안내 -->
        <el-dialog
          :title="$t('selfCertification.title')"
          :visible.sync="needVerification"
          :show-close="false"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          class="modal-type01 popup"
          center
        >
          <div class="text-center">
            <p
              class="text-type01 mgb25"
              v-html="$t('selfCertification.completeAuthenticationProcess')"
            ></p>
          </div>
          <div slot="footer" class="dialog-footer" flec fjc>
            <router-link
              tag="button"
              to="/"
              class="btn-style01"
              @click.native="needVerification = false"
              >{{ $t("confirm.cancel") }}</router-link
            >
            <router-link
              tag="button"
              :to="{ name: 'confirm' }"
              @click.native="needVerification = false"
              class
              >{{ $t("confirm.ok") }}</router-link
            >
          </div>
        </el-dialog>

        <!-- 수수료 변경 안내 -->
        <el-dialog
          :title="$t('notice.title.outfeeChanged1')"
          :visible.sync="feeChangeModal"
          :show-close="false"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          class="modal-type01 popup"
          center
        >
          <div class="text-center">
            <p
              class="text-type01 mgb25"
              v-html="$t('notice.title.outfeeChanged2')"
            ></p>
          </div>
          <div slot="footer" class="dialog-footer" flec fjc>
            <button
              @click="feeChangedResult"
              @keyup.enter="feeChangedResult"
              class
            >
              {{ $t("confirm.ok") }}
            </button>
          </div>
        </el-dialog>

        <!-- 거래소 선택 모달 -->
        <el-dialog
          :visible.sync="selectModal"
          title="거래소 선택"
          :close-on-click-modal="false"
          class="authID-modal withdraw-exchange"
        >
          <div v-if="selectItemsKr.length > 0" class="exchange-wrap">
            <p class="pb10">국내 거래소</p>
            <div>
              <el-radio-group
                v-model="selectModalList"
                @change="changeSelectModal"
              >
                <div>
                  <div
                    v-for="(item, index) in selectItemsKr"
                    :key="index"
                    @change="selectedItem(item.vaspId)"
                    class="fs14 pt10 pb10 pr20"
                  >
                    <el-radio
                      :label="item.vaspName"
                      class="radio normal"
                    ></el-radio>
                  </div>
                </div>
              </el-radio-group>
            </div>
          </div>
          <div v-if="selectItemsOverSea.length > 0" class="exchange-wrap">
            <p>해외 거래소</p>
            <div>
              <el-radio-group
                v-model="selectModalList"
                @change="changeSelectModal"
              >
                <div>
                  <div
                    v-for="(item, index) in selectItemsOverSea"
                    :key="index"
                    @change="selectedItem(item.vaspId)"
                    class="fs14 mt10 mb10 pr20"
                  >
                    <el-radio :label="item.vaspName"></el-radio>
                  </div>
                </div>
              </el-radio-group>
            </div>
          </div>
          <div
            v-if="selectItemsPersonalWallet.length > 0"
            class="exchange-wrap"
          >
            <p>기타</p>
            <div>
              <el-radio-group
                v-model="selectModalList"
                @change="changeSelectModal"
              >
                <div>
                  <div
                    v-for="(item, index) in selectItemsPersonalWallet"
                    :key="index"
                    @change="selectedItem(item.vaspId)"
                    class="fs14 mt10 mb10 pr20"
                  >
                    <el-radio :label="item.vaspName"></el-radio>
                  </div>
                </div>
              </el-radio-group>
            </div>
          </div>
        </el-dialog>
        <!-- // 거래소 선택 모달 -->
      </div>
    </div>
    <!-- // 정상 -->
  </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapGetters } from "vuex";

import axios from "axios";
import Moment from "moment";
import Decimal from "decimal.js";

import GlobalEvent from "@/common/Event";
import SelectJs from "@/components/common/Select";
import Api from "@/common/Api";
import AssetHeader from "../component/asset/header";
import { hasTag, tagRequired } from "@/common/CoinUtil";
import * as coinData from "@/util/coinData";
import { authIDModal } from "@/common/authIdModal";

let addressResult = "Y";

const isLiveServer =
  window.location.hostname === "m.flybit.com" ||
  window.location.hostname === "m.v1.flybit.com";

const instance = axios.create({
  baseURL: isLiveServer
    ? "https://third.flybit.com"
    : "https://third.dev.flybit.com",
  timeout: 1000,
});

export default {
  components: {
    SelectJs,
    AssetHeader,
  },
  async created() {
    this.useNoticeApi();

    GlobalEvent.$on("uploadComplete", () => {
      this.withdrawComfirmed();
    });
    this.$store.dispatch("getCoinSetting");

    if (this.coin[this.$route.params.coin]) {
      // 딥카피
      this.activeCoin = _.cloneDeep(this.coin[this.$route.params.coin]);

      if (this.activeCoin.subCoins) {
        // this.activeCoin.subCoins.length = 2; // bsc 가림용 임시 코드

        this.activeCoin.subCoins.forEach((subCoin, index) => {
          subCoin.active = false;

          // 탭 active 값 넣어주기
          if (index === 0) {
            subCoin.active = true;
          }

          // TRC 수수료 넣어주기
          if (subCoin.title === "TRC-20") {
            this.trcFee = subCoin.outFee;
          }
        });
      }
    }

    // 본인 인증 & 계좌 등록 여부 확인
    if (this.accounts.vrAccount == null) {
      this.accountModal = true;
      // this.accountAuthFailModal.show = true;
      return false;
    }
  },
  async mounted() {
    if (!authIDModal(this.userInfo)) {
      return;
    }

    if (this.userInfo.foreignYn == "N" && this.authLevel < 2) {
      //미인증 시 인증필요
      // GlobalEvent.modal({ modalName: "needVerification", show: true });
      this.needVerification = true;
    }
    const phone = await Api.User.getUserPrivateInfo("phone");
    if (phone) {
      this.phone = phone.data.result.data;
    }

    this.$store.dispatch("updateUserInfo").then(() => {
      if (this.withdrawalBanned) {
        this.notiBannedModal = true;
        return false;
      }
    });
    setInterval(this.remainTime, 1000);
    this.coinId = this.$route.params.coin || "KRW";

    this.setCoin(this.coinId);

    if (!this.noDepositAddress) {
      this.getAddrByCoins();
    }
  },
  data() {
    return {
      selectModalList: "0",
      totalExchangeData: [],
      selectItemsKr: [],
      selectItemsOverSea: [],
      selectItemsPersonalWallet: [],
      selectModal: false,
      vaspId: "",
      needAddressee: false,
      activeCoin: {},
      trcFee: "",
      coinId: "BTC",
      type: "type04",
      phone: "",
      //sms 인증
      authCode: "",
      inputAmount: "",
      withdrawResult: {},
      withdrawForm: {
        amount: 0,
        address: "",
        tag: "",
      },
      withdrawLimit: {
        limit: {
          once: 0,
          day: 0,
          month: 0,
        },
        avail: {
          once: 0,
          day: 0,
          month: 0,
        },
      },
      accountAuthFailModal: {
        show: false,
      },
      foreignNotAllowedModal: {
        show: false,
      },
      kycForeignNotAllowedModal: {
        show: false,
      },
      DA_CODE: false,
      addrModal: false,
      addresses: [],
      addrData: {
        coinId: "BTC",
        accountName: "",
        address: "",
        tag: "",
        addrList: [],
      },
      addrConfirm: false,
      addrConfirmModal: false,
      withdrawUnableModal: false,
      uploadRemitModal: false,
      paginationPer: 3,
      page: {
        currentPage: 1,
      },
      pagination: {},

      loginContent: true,
      notiBannedModal: false,
      needVerification: false,
      feeChangeModal: false,
      clickCheckButton: false,
      clickCheckTagButton: false,
      disabledWithdrawBtn: true,
      local: "",
      coinInfoRes: {},
      // checkCoin: {},
      checkTrackUrl: "",
      purposeList: "", //거래목적 선택 list v-model
      walletType: 1,
      disabledPersonalWallet: false,
      platformId: "",
      subCoinsIndex: 0,
      checkTrackUrl: "",
      noticeTitle: "",
      noticeDesc: "",
    };
  },
  computed: {
    ...mapState(["Server"]),
    ...mapGetters([
      "coin",
      "authLevel",
      "useOTP",
      "authStepLevel",
      "walletByCoinName",
      "getCoinById",
      "userInfo",
      "useOTP",
      "withdrawalBanned",
      "accounts",
      "userName",
      "authmPhone",
    ]),
    selectedERC() {
      if (!this.activeCoin.subCoins) return false;

      const isERC = this.activeCoin.subCoins.find(
        (coin) => coin.title === "ERC-20"
      );

      return isERC ? isERC.active : false;
    },
    selectedTRC() {
      if (!this.activeCoin.subCoins) return false;
      const isTRC = this.activeCoin.subCoins.find(
        (coin) => coin.title === "TRC-20"
      );
      return isTRC ? isTRC.active : false;
    },
    coinOption() {
      let list = _.map(this.coin, (coin, code) => {
        if (coin.ioInEnable == "N") {
          return {
            name: ``,
            value: ``,
          };
        } else if (coin.ioOutEnable == "N") {
          return {
            name: ``,
            value: ``,
          };
        }
        return {
          name: `${coin.name} (${code})`,
          value: code,
        };
      });

      list = list.filter((coin) => {
        return coin.name != "";
      });
      return list;
    },
    validAddr() {
      if (this.walletType === 1) {
        return _.filter(this.addresses, (addr) => {
          return addr.coinId === this.activeCoin.id;
        });
      } else {
        return this.walletAddresses;
      }
    },
    wallet() {
      return this.walletByCoinName(this.coinId);
    },
    withdrawAddr() {
      if (this.walletType === 1) {
        return [
          { value: false, name: this.$t("withdraw.depositAddressSelect ") },
          ..._.map(this.validAddr, (addr, i) => ({
            name: addr.name,
            value: i,
          })),
        ];
      } else {
        return [
          { value: false, name: "개인지갑 주소 선택" },
          ..._.map(this.validAddr, (addr, i) => ({
            name: addr.nick,
            value: i,
          })),
        ];
      }
    },
    fee() {
      return this.activeCoin.outFee;
    },
    minAmount() {
      return this.activeCoin.minOut;
    },
    maxAmount() {
      const minAmount = Math.min(
        this.wallet.available,
        this.withdrawLimit.avail.once,
        this.withdrawLimit.avail.day,
        this.withdrawLimit.avail.month
      );
      const result = _.subtract(minAmount, this.fee);
      if (minAmount > 0 && result > 0) {
        return _.subtract(minAmount, this.fee);
      }
      return 0;
    },
    localMaxAmount() {
      const minAmount = Math.min(
        this.wallet.available,
        this.withdrawLimit.avail.once,
        this.withdrawLimit.avail.day,
        this.withdrawLimit.avail.month
      );
      const result = _.subtract(minAmount, this.fee);
      if (minAmount > 0 && result > 0) {
        return _.subtract(minAmount, this.fee);
      }
      return 0;
    },
    trcMaxAmount() {
      const minAmount = Math.min(
        this.wallet.available,
        this.withdrawLimit.avail.once,
        this.withdrawLimit.avail.day,
        this.withdrawLimit.avail.month
      );
      const result = _.subtract(minAmount, this.trcFee);
      if (minAmount > 0 && result > 0) {
        return _.subtract(minAmount, this.trcFee);
      }
      return 0;
    },
    finalWithdraw() {
      const amount = parseFloat(this.inputAmount) || 0;
      if (this.activeCoin.code == "KRW") {
        return Number(this.inputAmount) + this.fee;
      }
      if (this.selectedTRC == true) return Decimal(amount).add(this.trcFee);
      return +Decimal(amount).add(this.local == "true" ? 0 : this.fee);
    },
    kycReturnUrl() {
      return this.$router.push(`/mypage`);
    },
    // 신원인증 이후 변경된 인증레벨
    newAuthLevel() {
      if (this.userInfo.dueDiligenceInfo) {
        const authId = this.userInfo.dueDiligenceInfo.sbStatus;

        // 가입, 이메일 인증 시
        if (this.authStep == "N" || this.authStep == "E") {
          return 0;
          // 이메일 인증 + 신원인증 시
        } else if ((authId && authId == "E") || (authId && authId == "RE")) {
          return 1;
        }
      } else {
        return 0;
      }
    },
    disabledWithdraw() {
      if (this.inputAmount && this.inputAmount > 0) {
        return false;
      } else {
        return true;
      }
      // if (
      //   (this.disabledWithdrawBtn && this.activeCoin.code !== "KRW") ||
      //   this.inputAmount.length == 0
      // ) {
      //   if (this.selectModalList == "0") {
      //     return true;
      //   }
      //   return true;
      // }
    },
    // 입금 주소 없을 때
    noDepositAddress() {
      if (this.walletByCoinName(this.coinId).address) {
        return false;
      } else {
        return true;
      }
    },
    addressLists() {
      if (this.walletType === 1) {
        return this.addresses;
      } else {
        return this.walletAddresses;
      }
    },
    title() {
      return this.addrData.coinId + " 주소록";
    },
    disabledInput() {
      if (this.vaspId == "" || this.walletType === 2) {
        return true;
      } else {
        return false;
      }
      // // 입금 주소, 태그 input disabled 조건
      // if (this.walletType === 2 && this.vaspId == "") {
      //   return true;
      // } else {
      //   return false;
      // }
    },
    disabledAmount() {
      if (this.walletType === 1) {
        if (this.local === "" || this.withdrawForm.address === "") {
          return true;
        } else {
          return false;
        }
      } else if (
        this.walletType === 2 &&
        this.withdrawForm.address.length > 0
      ) {
        return false;
      }

      return true;
    },
  },

  methods: {
    checkInput() {
      this.local = "";
      this.inputAmount = "";
      if (this.withdrawForm.address == "") {
        this.DA_CODE = false;
      }
      if (this.withdrawForm.tag == "") {
        this.DA_CODE = false;
      }
    },
    setCoin(coinId) {
      if (coinId === "KRW") {
        // 외국인 여부 확인
        if (this.$store.getters.isForeign) {
          this.foreignNotAllowedModal.show = true;
          return false;
        }
        // if (this.userInfo.foreignYn == "N" && this.accounts.deposit === null) {
        //   this.accountAuthFailModal.show = true;
        //   return false;
        // }
      }

      //외국인 KYC 여부확인
      if (this.$store.getters.isForeign) {
        if (this.$store.getters.getKYCForeign !== "E") {
          this.kycForeignNotAllowedModal.show = true;
          return false;
        }
      }

      this.coinId = coinId;
      this.getAddrData({
        coinId: this.activeCoin.id,
        page: this.page.currentPage,
        count: 99,
      });
      this.getLimit(this.activeCoin.id);
      this.inputAmount = "";
    },
    getAddrData(options = {}) {
      const params = {
        // count: 5,
        ...options,
      };

      Api.User.getAddrList(params).then((response) => {
        if (_.has(options, "coinId")) {
          this.addresses = response.body;
          this.pagination = response.pagination;
          this.pagination.total = _.get(response.body, [0, "cnt"], 0);
        } else {
          this.addresses = response.body;
          this.addrData.addrList = response.body;
          this.pagination = response.pagination;
          this.pagination.total = _.get(response.body, [0, "cnt"], 0);
        }
      });
    },
    getLimit(coinId) {
      return Api.Transfer.getWithdrawLimit(coinId).then((response) => {
        this.withdrawLimit = {
          avail: response.body.limit,
          limit: response.body.levelLimit,
        };
      });
    },
    // 내부 전송 주소 확인
    async checkInnerAddress(coinId) {
      if (this.Server.version > 3 && this.selectModalList == "0") {
        this.$msgbox({
          message: "받는 거래소를 선택하세요.",
          type: "default",
        });
        return;
      }

      /* 출금주소 유효성 검사 */
      const address = this.withdrawForm.address; // 입력 출금 주소

      const address_regex = /^[a-zA-Z0-9.-:]*$/; // 기본 체크식
      const ETH_regex = /^0x[a-fA-F0-9]{40}$/; // eth 체크식
      const TRX_regex = /^T[a-zA-z0-9]{33}$/; // trx 체크식
      const BTC_regex = /^([13mn][a-km-zA-HJ-NP-Z1-9]{25,33}|bc1[a-z0-9]{39,59})$/; // btc 체크식
      const EOS_regex = /^[a-z0-9.]{1,12}$/; // EOS 체크식
      const RIP_regex = /^r[0-9a-zA-Z]{24,34}/; // ripple 체크식

      if (this.coinId !== "KRW") {
        // 기본 코인 정규식 true
        if (address_regex.test(address) && address.length > 4) {
          // subCoin 있을 때

          if (this.activeCoin.subCoins) {
            const subCoin = this.activeCoin.subCoins[this.subCoinsIndex];
            this.checkSubTrackUrl = subCoin.trackUrl;
          } else {
            this.checkSubTrackUrl = this.activeCoin.trackUrl;
          }

          const checkETH = this.checkSubTrackUrl.includes("etherscan"); // 이더스캔 용
          const checkTRX = this.checkSubTrackUrl.includes("tronscan"); // 트론스캔 용
          const checkBTC = this.checkSubTrackUrl.includes("btc"); // btc 용
          const checkBSC = this.checkSubTrackUrl.includes("bscscan"); // bsc 용
          const checkKLA = this.checkSubTrackUrl.includes("klaytn"); // klaytn 용
          const checkEOS = this.checkSubTrackUrl.includes("eosflare"); // eos 용
          const checkRIP = this.checkSubTrackUrl.includes("ripple"); // ripple 용

          if (checkETH || checkBSC || checkKLA) {
            if (!ETH_regex.test(address)) {
              this.$msgbox({
                title: this.$t("notice.title.error"),
                message: "받는 주소가 올바르지 않습니다.",
                type: "error",
              });
              return;
            }
          } else if (checkTRX) {
            if (!TRX_regex.test(address)) {
              this.$msgbox({
                title: this.$t("notice.title.error"),
                message: "받는 주소가 올바르지 않습니다.",
                type: "error",
              });
              return;
            }
          } else if (checkBTC) {
            if (!BTC_regex.test(address)) {
              this.$msgbox({
                title: this.$t("notice.title.error"),
                message: "BTC 받는 주소가 올바르지 않습니다.",
                type: "error",
              });
              return;
            }
          } else if (checkEOS) {
            if (!EOS_regex.test(address)) {
              this.$msgbox({
                title: this.$t("notice.title.error"),
                message: "받는 주소가 올바르지 않습니다.",
                type: "error",
              });
              return;
            }
          } else if (checkRIP) {
            if (!RIP_regex.test(address)) {
              this.$msgbox({
                title: this.$t("notice.title.error"),
                message: "받는 주소가 올바르지 않습니다.",
                type: "error",
              });
              return;
            }
          }
          // 기본 코인 정규식 false
        } else {
          console.log("기본 코인 정규식 false");
          this.$msgbox({
            title: this.$t("notice.title.error"),
            message: "출금주소가 올바르지 않습니다.",
            type: "error",
          });
          return;
        }
      }

      // 태그 입력 칸 없는 경우
      if (this.withdrawForm.address == "") {
        this.clickCheckButton = true;
        this.disabledWithdrawBtn = true;
        return;
      } else {
        this.clickCheckButton = false;
        this.clickCheckTagButton = false;
        this.disabledWithdrawBtn = false;
      }

      // watch에 쓸 변수 선언
      this.prevTag = this.withdrawForm.tag;
      this.prevAddress = this.withdrawForm.address;
      // api 호출 : result true or false
      try {
        const { data } = await Api.Transfer.checkDepositInnerAddress(
          coinId,
          this.withdrawForm.address,
          this.withdrawForm.tag,
          this.vaspId
        );

        if (data.result === "true") {
          this.sendInnerAddress = true;
          this.local = data.result;

          this.$msgbox({
            title: this.$t("notice.title.attention"),
            message: this.$t("withdraw.notiFree[1]"),
            type: "default",
          });
        } else {
          this.sendInnerAddress = false;
          this.local = data.result;
          if (!this.selectedTRC) {
            this.$msgbox({
              title: this.$t("notice.title.attention"),
              message: "외부 출금 시 출금 수수료가 발생합니다.",
              type: "default",
            });
          }
        }
      } catch (err) {
        this.disabledWithdrawBtn = true;

        this.$msgbox({
          title: "안내",
          message: err.msg,
          type: "default",
        });
      }
    },
    // //내부 전송 주소 확인
    //입금주소 입력 인풋
    clickAddressInput() {
      this.withdrawForm.address = "";
      this.inputAmount = "";
    },
    //데스티네이션 태그 입력 인풋
    clickTagInput() {
      this.withdrawForm.tag = "";
      this.inputAmount = "";
    },
    // checkAmount(e) {
    //   let value = e.target.value;
    //   value = +parseFloat(value).toFixed(8);
    //   if (isNaN(value)) {
    //     value = 0;
    //   }
    //   this.withdrawForm.amount = value;
    //   this.$forceUpdate();
    //   return false;
    // },
    // 출금 수량 최대값
    maxAmountChx(decimalPoint) {
      const pow = Math.pow(10, decimalPoint);

      let amount = 0;
      if (this.local === "true") {
        amount = this.localMaxAmount;
      } else if (this.selectedTRC) {
        amount = this.trcMaxAmount;
      } else {
        amount = this.maxAmount;
      }
      // const amount =
      //   this.local == "false"
      //     ? !this.selectedTRC
      //       ? this.maxAmount
      //       : this.trcMaxAmount
      //     : this.localMaxAmount;
      const temp1 = amount * pow;
      const temp2 = Math.floor(temp1);
      const result = temp2 / pow;
      if (this.activeCoin.code == "KRW") {
        this.inputAmount = Math.floor(this.maxAmount);
      } else {
        this.inputAmount = result;
      }
    },
    addressChx() {
      // 출금주소체크
      if (this.withdrawForm.address == "") {
        this.$vs.notify({
          title: this.$t("notice.title.attention"),
          text: this.$t("notice.content.enterwithdrawalAddress"),
          position: "top-left",
          color: "danger",
        });
        return;
      }
      this.getAddressValidator();
    },
    // 출금 최종 팝업 확인 클릭 시
    getAddressValidator() {
      const params = {
        coinCode: this.coinId,
        address: this.withdrawForm.address,
      };
      return Api.Aspect.getWalletAddress(params).then((response) => {
        addressResult = response.body;
        let msg = [];
        switch (addressResult) {
          case "N":
            msg = ["받는 주소가 올바르지 않습니다.", "error"];
            break;
          case "Y":
            msg = ["출금 가능한 주소 입니다.", "warning"];
            break;
          case "C":
            msg = [
              "스마트컨트랙트를 지원하는 지갑주소로 출금을 요청하였습니다. 플라이빗에서는 미지원 서비스로, 출금할 수 없습니다.",
              "error",
            ];
            break;
        }
        // const msg = (addressResult == "N") ? ["받는 주소가 올바르지 않습니다.", "error"] : ["출금 가능한 주소 입니다.", "warning"];
        this.$notify({
          title: this.$t("notice.title.attention"),
          message: msg[0],
          type: msg[1],
          customClass: "dexko-noti",
          position: "top-left",
        });
      });
    },
    setAddrCoin(coinId) {
      this.addrData.coinId = coinId;
      this.getAddrData({
        coinId: this.coin[coinId].id,
        page: this.page.currentPage,
        count: 3,
      });
    },
    registAddr() {
      if (this.walletType === 2) {
        this.addrModal = false;
        return;
      }
      if (!this.addrData.address) {
        this.$vs.notify({
          title: this.$t("notice.title.uploadFailed"),
          text: this.$t("notice.content.enterAddress"),
          position: "top-left",
          color: "danger",
        });
        return false;
      }
      if (this.tagRequired(this.addrData.coinId) && !this.addrData.tag) {
        this.$vs.notify({
          title: this.$t("notice.title.uploadFailed"),
          message: this.$t("notice.content.enterDestinationTag"),
          type: "error",
          position: "top-left",
        });
        return false;
      }
      if (!this.addrData.accountName) {
        this.$vs.notify({
          title: this.$t("notice.title.uploadFailed"),
          text: this.$t("notice.content.enteraddressName"),
          position: "top-left",
          color: "danger",
        });
      }

      Api.User.addAddr({
        coinId: this.coin[this.addrData.coinId].id,
        address: this.addrData.address,
        tag: this.addrData.tag,
        name: this.addrData.accountName,
      }).then((response) => {
        this.$vs.notify({
          title: this.$t("notice.title.uploaded"),
          text: this.$t("notice.content.newAddressUpdated"),
          position: "top-left",
          color: "danger",
        });
        this.addrData.accountName = "";
        this.addrData.address = "";

        this.getAddrData({
          coinId: this.coin[this.addrData.coinId].id,
          page: this.page.currentPage,
          count: 3,
        });
      });
    },

    closeAddrModal() {
      this.addrModal = false;
      this.getAddrData({
        coinId: this.coin[this.addrData.coinId].id,
        page: 1,
        count: 999,
      });
    },

    showAddrModal() {
      this.setAddrCoin(this.coinId);
      this.addrModal = true;
    },
    changeAddrPage() {
      this.getAddrData({
        coinId: this.coin[this.addrData.coinId].id,
        page: this.page.currentPage,
        count: 3,
      });
    },
    setWithdraw(DA_CODE) {
      console.log("DA_CODE", DA_CODE);
      this.local = "";
      this.inputAmount = "";
      if (this.selectModalList === "0") {
        this.$vs.notify({
          title: this.$t("notice.title.attention"),
          text: "받는 거래소를 선택하세요.",
          position: "top-left",
          color: "danger",
        });
        return;
      }
      this.DA_CODE = DA_CODE;
      if (DA_CODE !== false) {
        this.withdrawForm.address = this.validAddr[DA_CODE].address;
        this.withdrawForm.tag = this.validAddr[DA_CODE].tag;
        if (this.withdrawForm.tag == undefined) {
          this.withdrawForm.tag = "";
        }
      } else {
        this.withdrawForm.address = "";
        this.withdrawForm.tag = "";
      }
    },
    deleteRow(id) {
      this.$confirm("선택하신 주소정보를 목록에서 삭제 하시겠습니까?")
        .then(() => {
          Api.User.deleteAddr(id);
        })
        .then((response) => {
          this.$vs.notify({
            title: this.$t("notice.title.attention"),
            text: this.$t("notice.content.deleted"),
            position: "top-left",
            color: "danger",
          });

          this.getAddrData({
            coinId: this.coin[this.addrData.coinId].id,
            count: 3,
            page: this.page.currentPage,
          });
        });
    },
    async withdraw() {
      // 신원인증
      if (authIDModal(this.userInfo) === false) {
        return;
      }

      //내부전송
      if (this.sendInnerAddress == true) {
        this.needAddressee = false;
        // 외부전송
      } else {
        const param = {
          ciCode: this.activeCoin.code,
          amount: this.inputAmount,
          address: this.withdrawForm.address,
          destTag: this.withdrawForm.tag,
        };
        const res = await Api.Transfer.priceVerifications(param);
        const data = res.data.result;

        if (
          data.authAddress == "N" &&
          data.priceLimit == "Y" &&
          (this.vaspId == "0000" || this.vaspId == "0001")
        ) {
          this.$msgbox({
            title: this.$t("notice.title.attention"),
            message:
              "기타 거래소/미 인증된 개인지갑 선택 시 100만원 이상 출금할 수 없습니다.",
            type: "warning",
          });
          return;
        } else {
          if (data.authAddress == "Y") {
            this.needAddressee = false; // 트래블룰
          } else {
            if (
              data.priceLimit == "N" &&
              (this.vaspId == "0000" || this.vaspId == "0001")
            ) {
              this.needAddressee = false; // 트래블룰
            } else {
              this.needAddressee = true; // 트래블룰
            }
          }
        }
      }

      // // 인증센터 OTP 미인증 시 : 원화
      // if (this.activeCoin.code == "KRW" && this.authStepLevel == 1) {
      //   this.$vs.notify({
      //     title: this.$t("notice.title.error"),
      //     text: this.$t("withdraw.certificationOTP"),
      //     position: "top-left",
      //     color: "danger",
      //   });
      //   return false;
      // }
      // // 인증센터 휴대폰 미인증 시 : 원화
      // if (this.activeCoin.code == "KRW" && this.authStepLevel == 0) {
      //   this.$vs.notify({
      //     title: this.$t("notice.title.error"),
      //     text: this.$t("withdraw.certificationSMS"),
      //     position: "top-left",
      //     color: "danger",
      //   });
      //   return false;
      // }
      // 출금 수량 미입력 시
      if (this.inputAmount == "") {
        if (this.coinId == "KRW") {
          this.$vs.notify({
            title: this.$t("notice.title.error"),
            text: this.$t("notice.content.enterWithdrawalPrice"),
            position: "top-left",
            color: "danger",
          });
          return false;
        } else {
          this.$vs.notify({
            title: this.$t("notice.title.error"),
            text: this.$t("notice.content.enterWithdrawalAmount"),
            position: "top-left",
            color: "danger",
          });
          return false;
        }
      }
      // 받는 주소 미입력 시 : 원화 아님
      if (this.activeCoin.code !== "KRW" && !this.withdrawForm.address) {
        this.$vs.notify({
          title: this.$t("notice.title.error"),
          text: this.$t("notice.content.noWithdrawalAddressEntered"),
          position: "top-left",
          color: "danger",
        });
        return false;
      }
      // 받는 주소 미입력 시 : usdt
      if (this.activeCoin.code == "USDT" && this.selectedERC) {
        if (this.withdrawForm.address.startsWith("0x")) {
        } else {
          this.$vs.notify({
            title: this.$t("notice.title.attention"),
            text: this.$t("notice.content.checkWithdrawalAddressEntered"),
            position: "top-left",
            color: "danger",
          });
          return false;
        }
      } else if (this.activeCoin.code == "USDT" && this.selectedTRC) {
        if (this.withdrawForm.address.startsWith("T")) {
        } else {
          this.$vs.notify({
            title: this.$t("notice.title.attention"),
            text: this.$t("notice.content.checkWithdrawalAddressEntered"),
            position: "top-left",
            color: "danger",
          });
          return false;
        }
      }

      if (this.withdrawForm.tag) {
        this.withdrawForm.tag = this.withdrawForm.tag.trim();
      }
      // 데스티네이션 태그 미입력 시
      if (
        this.tagRequired(this.coinId) &&
        (!this.withdrawForm.tag || this.withdrawForm.tag.length <= 2)
      ) {
        this.$vs.notify({
          title: this.$t("notice.title.error"),
          text: this.$t("notice.content.destinationTagRequired"),
          position: "top-left",
          color: "danger",
        });
        return false;
      }
      // 출금 가능 금액 초과 시
      if (Number(this.inputAmount) > Math.floor(this.maxAmount)) {
        // krw
        if (this.activeCoin.code == "KRW") {
          this.$vs.notify({
            title: this.$t("notice.title.error"),
            text: this.$t("notice.content.maximumWithdrawalPrice"),
            position: "top-left",
            color: "danger",
          });
          return false;
        } else {
          // trc
          if (this.selectedTRC == true) {
            if (Number(this.inputAmount) > this.trcMaxAmount) {
              this.$vs.notify({
                title: this.$t("notice.title.error"),
                text: this.$t("notice.content.maximumWithdrawalAmount"),
                position: "top-left",
                color: "danger",
              });
              return false;
            }
            // 로컬
          } else if (this.local == "true") {
            if (Number(this.inputAmount) > this.localMaxAmount) {
              this.$vs.notify({
                title: this.$t("notice.title.error"),
                text: this.$t("notice.content.maximumWithdrawalAmount"),
                position: "top-left",
                color: "danger",
              });
              return false;
            }
            // !krw && !trc && !local
          } else {
            if (Number(this.inputAmount) > this.maxAmount) {
              this.$vs.notify({
                title: this.$t("notice.title.error"),
                text: this.$t("notice.content.maximumWithdrawalAmount"),
                position: "top-left",
                color: "danger",
              });
              return false;
            }
          }
        }
      }

      // 최소금액보다 적을 때
      if (Number(this.inputAmount) < this.minAmount) {
        if (this.activeCoin.code === "KRW") {
          this.$vs.notify({
            title: this.$t("notice.title.error"),
            text: this.$t("notice.content.minimumWithdrawalPrice", [
              this.activeCoin.minOut,
            ]),
            position: "top-left",
            color: "danger",
          });
          return false;
        } else {
          if (Number(this.inputAmount) < this.minAmount) {
            this.$vs.notify({
              title: this.$t("notice.title.error"),
              text: this.$t("notice.content.minimumWithdrawalAmount", [
                this.activeCoin.minOut,
              ]),
              position: "top-left",
              color: "danger",
            });
            return false;
          }
        }
      }

      if (this.coinId !== "KRW" && addressResult == "N") {
        this.addressChx();
        return false;
      }

      const feeChanged = await this.feeChanged();
      if (feeChanged) {
        this.feeChangeModal = true;
        this.$store.dispatch("getCoinSetting");
        return false;
      }

      const isPolicy = await Api.isPolicyChange()
        .then((e) => true)
        .catch((e) => {
          if (!_.has(e, "msg") && !_.has(e, "code")) {
            return false;
          }
          const { code, message } = _.get(e, ["response", "data", "header"]);

          if (code == 4200) {
            this.$vs.notify({
              title: this.$t("notice.title.error"),
              text: this.$t("notice.content.changeCertification"),
              position: "top-left",
              color: "danger",
            });
            return false;
          }

          this.$vs.notify({
            title: this.$t("notice.title.error"),
            text: e.response.data.header.message,
            position: "top-left",
            color: "danger",
          });

          this.addrConfirm = false;
          this.addrConfirmModal = false;

          return false;
        });

      //원화출금, 가상자산 출금 제한
      if (isPolicy) {
        if (this.coinId === "KRW") {
          Api.getFirstKrwDays()
            .then((response) => {
              this.addrConfirm = true;
              this.withdrawComfirmed();
            })
            .catch((e) => {
              this.$vs.notify({
                title: this.$t("notice.title.error"),
                text: this.$t(
                  "금융사고 예방을 위해 원화출금은 KRW 첫 입금 후 72시간, 디지털 자산 출금은 KRW 마지막 입금 후 72시간 동안 출금이 제한됩니다."
                ),
                position: "top-left",
                color: "danger",
              });
              //this.withdrawComfirmed();
              this.addrConfirm = false;
              this.addrConfirmModal = false;
              return false;
            });
        } else {
          Api.getKrwDays()
            .then((response) => {
              this.addrConfirm = false;
              this.addrConfirmModal = true;
            })
            .catch((e) => {
              if (e.status == "400") {
                this.$vs.notify({
                  title: this.$t("notice.title.error"),
                  text: this.$t("notice.content.72hoursLastKRWDeposit"),
                  position: "top-left",
                  color: "danger",
                });
              }
              this.addrConfirm = false;
              this.addrConfirmModal = false;
              return false;
            });
        }
      }
    },
    async withdrawComfirmed() {
      // addconfirm
      if (!this.addrConfirm) {
        return false;
      }

      const authType = this.useOTP ? "O" : "P";
      //ERC-20 or TRC-20
      const seToken =
        this.activeCoin.code != "USDT"
          ? ""
          : this.selectedERC
          ? "ETH"
          : this.selectedTRC
          ? "TRX"
          : "";

      const fee = this.selectedTRC == true ? this.trcFee : this.fee;
      // const fee = this.local == true ? 0 : getFee;
      const params = {
        coin: this.activeCoin.code,
        activeCoin: this.activeCoin,
        fee,
        finalWithdraw: this.finalWithdraw,
        coinId: this.activeCoin.id,
        tranferType: "O",
        amount: this.inputAmount,
        toAddress: this.withdrawForm.address,
        vaspId: this.vaspId, // 기타거래소 "0000"
        needAddressee: this.needAddressee,
        phone: this.phone,
        toParam: {
          tag: this.withdrawForm.tag,
        },
        authType,
        //ERC-20 or TRC-20
        seToken,
      };
      this.$router.push({
        name: "withdrawConfirm",
        params,
        query: { local: this.local },
      });
    },
    feeChangedResult() {
      this.withdrawForm.address = "";
      // this.withdrawForm.amount = 0;
      this.inputAmount = 0;
      this.authCode = "";

      location.reload();
      this.feeChangeModal = false;
    },

    hasTag,
    tagRequired,

    async feeChanged() {
      const response = await Api.Setting.getCoinInfo();
      const { body } = response;
      const coins = _.keyBy(body, "code");
      const cicode = this.activeCoin.code;

      const isChange = coins[cicode].outFee !== this.coin[cicode].outFee;
      return isChange;
    },
    clickERC() {
      this.selectedERC = true;
      this.selectedTRC = false;
      this.withdrawForm.address = "";
      this.inputAmount = "";
    },
    clickTRC() {
      this.selectedTRC = true;
      this.selectedERC = false;
      this.withdrawForm.address = "";
      this.inputAmount = "";
    },
    clickSubCoins(type, index) {
      // USDT 네트워크 탭 선택 시 값 리셋
      this.walletType = 1;
      this.selectModalList = "0"; // 거래소 선택 버튼 문구\
      this.vaspId = ""; // 거래소 code
      this.withdrawForm.address = "";
      this.withdrawForm.tag = "";
      this.DA_CODE = false;

      this.subCoinsIndex = index;

      this.getAddrByCoins();

      // 딥카피
      const newSubCoins = _.cloneDeep(this.activeCoin.subCoins);

      // 탭버튼 active 여부
      newSubCoins.forEach((subCoin, coinIndex) => {
        subCoin.active = false;
        if (subCoin.title === type && index === coinIndex) {
          subCoin.active = true;
        }
      });

      this.activeCoin.subCoins = newSubCoins;
      this.withdrawForm.address = "";
      this.inputAmount = "";
      this.local = "";
    },
    getLimitAmount(amount, decimalPoint) {
      const newPattern = `^\\d*[.]\\d{` + (decimalPoint + 1) + `}$`; // 소수점 자릿수 제한 정규식 변수 적용
      const limitDecimal = new RegExp(newPattern); // 변수 적용한 새 정규식
      if (limitDecimal.test(amount)) {
        this.inputAmount = this.inputAmount.slice(0, -1);
        return "";
      }
    },

    // 거래소 선택 팝업
    async openSelectModal() {
      if (this.walletType === 2) {
        return;
      }
      try {
        const getData = await Api.Transfer.getExchangeLists();
        // 거래소 sort
        this.totalExchangeData = getData.data.result.sort((a, b) =>
          a.vaspName.toLowerCase() < b.vaspName.toLowerCase() ? -1 : 1
        );
        // 국내거래소
        this.selectItemsKr = this.totalExchangeData.filter((data) =>
          data.country.toUpperCase().includes("KOREA")
        );
        // 해외거래소
        this.selectItemsOverSea = this.totalExchangeData.filter(
          (data) =>
            !data.country.toUpperCase().includes("KOREA") &&
            !data.country.toUpperCase().includes("ETC")
        );
        // 기타거래소
        this.selectItemsPersonalWallet = this.totalExchangeData.filter((data) =>
          data.country.toUpperCase().includes("ETC")
        );
        this.selectModal = true;
      } catch (error) {
        console.log(error);
        this.$notify({
          title: "오류",
          message: error.msg,
          type: "danger",
          position: "top-left",
          iconClass: "icon-custom",
          customClass: "buying-warning",
          duration: 3000,
        });
      }
    },
    // 거래소 라디오 버튼 선택 시
    changeSelectModal() {
      this.selectModal = false; //팝업 닫힘
      this.withdrawForm.address = "";
      this.withdrawForm.tag = "";
      this.inputAmount = "";
      this.DA_CODE = false;
    },
    selectedItem(vaspId) {
      this.vaspId = vaspId;
    },
    async selectedAddrType() {
      if (this.walletType === 1) {
        // 직접입력/즐겨찾기
        this.selectModalList = "0"; // 거래소 선택 버튼 문구\
        this.vaspId = ""; // 거래소 code
        this.inputAmount = ""; // 수량
        this.withdrawForm.address = "";
        this.withdrawForm.tag = "";
        this.DA_CODE = false;
        this.disabledWithdrawBtn = true;
        this.local = "";
      } else {
        this.selectModalList = "개인지갑";
        this.vaspId = "0001";
        this.inputAmount = ""; // 수량
        this.withdrawForm.address = "";
        this.withdrawForm.tag = "";
        this.DA_CODE = false;
        this.local = false;
      }
    },
    async getAddrByCoins() {
      // 코인별 인증주소 리스트
      try {
        if (this.activeCoin.platformId || this.activeCoin.authPlatformId) {
          this.platformId = this.activeCoin.platformId
            ? this.activeCoin.platformId
            : this.activeCoin.authPlatformId;
        } else if (this.activeCoin.subCoins) {
          const getSeToken = this.activeCoin.subCoins[this.subCoinsIndex];

          // seToken === coins.code인 id
          this.platformId = this.$store.getters.getCoinId(getSeToken.seToken);
        } else {
          this.disabledPersonalWallet = true;

          return;
        }

        const res = await Api.authAddr.getAddressesByCoins(this.platformId);
        if (res.body.length === 0 || !res.body) {
          this.disabledPersonalWallet = true;
        } else {
          this.walletAddresses = res.body;
          this.disabledPersonalWallet = false;
        }
      } catch (error) {
        this.$notify({
          title: "오류",
          message: error.msg,
          type: "danger",
          position: "top-left",
          iconClass: "icon-custom",
          customClass: "buying-warning",
          duration: 3000,
        });
      }
    },
    async useNoticeApi() {
      const { data } = await instance.get(`/termof/doWithdrawal`);
      // console.log("res", data.result.contents.terms[0]);
      const notice = data.result.contents.terms[0];
      this.noticeTitle = notice.title;
      this.noticeDesc = notice.content;
    },
  },
  watch: {
    amount: function(val) {
      if (val > this.maxAmount) val = this.maxAmount;
      // this.withdrawForm.amount = Number(val);
      Vue.nextTick(() => (this.amount = val));
    },
    inputAmount: function(val) {
      if (this.activeCoin.code == "KRW") {
        const result = `${val}`.replace(/\D/g, "");
        // .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return Vue.nextTick(() => (this.inputAmount = result));
      }

      var parts = val
        .toString()
        .replace(/,/g, "")
        .split(".");
      const result = parts[0] + (parts.length != 1 ? "." + parts[1] : "");

      // const result = `${val}`.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      Vue.nextTick(() => {
        this.inputAmount = result;
        // this.withdrawForm.amount = val.replace(/,/g, "");
      });
    },
    withdrawForm: {
      deep: true,
      handler() {
        if (this.activeCoin.tagYn === "Y") {
          if (
            this.prevTag != this.withdrawForm.tag ||
            this.prevAddress != this.withdrawForm.address
          ) {
            this.disabledWithdrawBtn = true;
          }
        } else {
          if (this.prevAddress != this.withdrawForm.address) {
            this.disabledWithdrawBtn = true;
          }
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "/src/styles/import.scss";

p {
  margin-bottom: 0;
}
/* 입출금 일시정지 */
.obstruct-wrap {
  p {
    margin-bottom: 0;
  }
  width: 100%;
  padding: 10px 12px;
  .title {
    font-size: 14px;
    font-weight: bold;
    color: #333;
  }
  .text-box {
    margin-top: 10px;
    padding: 10px;
    background-color: #fafafa;
    border-top: 1px solid #333;
    border-bottom: 1px solid #e6e6e6;
    p {
      font-size: 12px;
      color: #666;
      line-height: 22px;
    }
  }
}
.address-modal .el-dialog {
  width: calc(100% - 20px);
}
.address-modal .el-dialog--center .el-dialog__body {
  padding: 20px;
}
.el-dialog button.cancel {
  background: #b4b4b4;
  width: 120px;
  font-size: 13px;
  padding: 10px;
}
.modal-deposit-con {
  /* margin-top: -40px; */
}
.modal-deposit-con h3 {
  margin-bottom: 12px;
  color: #000;

  font-weight: bold;
  font-size: 15px;
  line-height: 24px;
}
.modal-deposit-con .add-regist {
  display: table;
  width: 100%;
  border-top: 1px solid $BlueGray600;
  border-bottom: 1px solid $BlueGray600;
}
.modal-deposit-con .add-regist > div {
  display: table-row;
}
.modal-deposit-con .add-regist > div > div {
  display: table-cell;
  height: 40px;
  /* border-top: 1px solid #d1d5da; */
  box-sizing: border-box;
  vertical-align: middle;
  &:last-of-type {
    /* border-bottom: 1px solid #d1d5da; */
  }
}
.modal-deposit-con .add-regist .tit {
  width: 120px;
  color: #000;
  /* font-weight: bold; */
  font-size: 14px;
  /* border-right: 1px solid #000; */
  background-color: #fafafa;
  text-align: center;
}
.modal-deposit-con .add-regist .txt {
  padding: 0 6px;
}
.modal-deposit-con .add-regist .txt .select-wrap {
  display: inline-block;
  height: 40px;
}
.btn-type02 {
  margin-top: 10px;
  text-align: right;
  margin-bottom: 20px;
}
.btn-type02 button {
  padding: 4px 12px;
  font-size: 12px;
}
.modal-deposit-con .add-cell {
  position: relative;
  padding-right: 30px;
  font-size: 11px;
}
.modal-deposit-con .add-cell .btn-delete01 {
  position: absolute;
  top: 0;
  right: 5px;
}
.modal-deposit-con .paging {
  margin-top: 10px;
}
.NFTS-description {
  margin-top: 8px;
  font-size: 12px;
}
/* 거래소 선택 */
.select-exchange {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 44px;
  /* padding: 14px 10px; */
  text-align: center;
  font-size: 14px;
  border: 1px solid #b4b4b4;
  border-radius: 3px;
  &.disabled {
    background-color: $WarmBlack100;
    color: $WarmBlack500;
  }
}
</style>
